import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const LiveMetrics = () => {
  const [metrics, setMetrics] = useState({
    projects: 0,
    clients: 0,
    roi: 0
  });

  const finalMetrics = {
    projects: 10,
    clients: 10,
    roi: 340
  };

  useEffect(() => {
    const duration = 2000; // 2 seconds
    const steps = 60;
    const stepDuration = duration / steps;

    const intervals = Object.keys(finalMetrics)?.map(key => {
      const increment = finalMetrics?.[key] / steps;
      let current = 0;
      
      return setInterval(() => {
        current += increment;
        if (current >= finalMetrics?.[key]) {
          current = finalMetrics?.[key];
          clearInterval(intervals?.find(interval => interval === this));
        }
        
        setMetrics(prev => ({
          ...prev,
          [key]: Math.floor(current)
        }));
      }, stepDuration);
    });

    return () => intervals?.forEach(interval => clearInterval(interval));
  }, []);

  const metricCards = [
    {
      icon: 'CheckCircle',
      value: metrics?.projects,
      label: 'Projects Completed',
      suffix: '+',
      color: 'text-success',
      bgColor: 'bg-success/10'
    },
    {
      icon: 'Users',
      value: metrics?.clients,
      label: 'Happy Clients',
      suffix: '+',
      color: 'text-trust',
      bgColor: 'bg-trust/10'
    },
    {
      icon: 'TrendingUp',
      value: metrics?.roi,
      label: 'Average ROI',
      suffix: '%',
      color: 'text-conversion',
      bgColor: 'bg-conversion/10'
    }
  ];

  return (
    <section className="py-16 bg-surface">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            Real Impact, Real Results
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Our success is measured by your growth. Here's what we've achieved together with our clients.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {metricCards?.map((metric, index) => (
            <div
              key={index}
              className="bg-card rounded-xl p-8 text-center brand-shadow brand-hover-lift brand-transition"
            >
              <div className={`inline-flex items-center justify-center w-16 h-16 rounded-full ${metric?.bgColor} mb-6`}>
                <Icon name={metric?.icon} size={32} className={metric?.color} />
              </div>
              
              <div className="space-y-2">
                <div className="text-4xl md:text-5xl font-bold text-foreground">
                  {metric?.value?.toLocaleString()}{metric?.suffix}
                </div>
                <p className="text-lg text-muted-foreground font-medium">
                  {metric?.label}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Live Update Indicator */}
        <div className="flex items-center justify-center mt-8 space-x-2">
          <div className="w-2 h-2 bg-success rounded-full animate-pulse"></div>
          <span className="text-sm text-muted-foreground">Live metrics updated in real-time</span>
        </div>
      </div>
    </section>
  );
};

export default LiveMetrics;